import React from 'react';

import {useTranslation} from "react-i18next";

import './UserProfilePage.scss';
import Hero from "../../common/Hero/Hero";
import CustomSignUp from "../../forms/CustomSignUp/CustomSignUp";
import ImageUploader from '../../common/ImageUploader/imageUploader';

const UserProfilePage = (props) => {
  const {t} = useTranslation();
  const municipal_user = !!(props.location.params && props.location.params.comunali);
  return (

    <div className={"UserProfile"} data-testid={"UserProfile"}>
      {municipal_user ?
        <Hero backTo={'/dashboard'}
              backToText={t("common.back.home")}
              title={t('dashboard.manager.card-three.new-user')}
              description={t('dashboard.manager.card-three.new-user-description')}/>
        :
        <Hero backTo={'/dashboard'}
              backToText={t("common.back.home")}
              title={t('dashboard.manage.modify.card-three.new-user')}
              description={t('dashboard.manage.modify.new-user-description')}/>
      }

      <div className="container">
        <p className={"col-sm-12 col-md-10 offset-md-1 case-step-mandatory-fields-legend paragraph-small-fs9"}>{t("mandatory.fields.legend")}</p>
      </div>

      {!municipal_user ?

        <ImageUploader/>

        : null
      }

      <CustomSignUp municipal={municipal_user}/>
    </div>

  )
};


export default UserProfilePage;
